'use client'; 
import React from "react";
import FooterText from "./footerText";
import SocialComp from "./socialComp";
import NewsLetterComp from "./newsletterComp";
import Link from "next/link";
import { track } from "@lib/track";
//import HeroSection from "./workshophero";

const Footer = () => {
  return (
    <div className="bg-[var(--bg-surface)] pt-5">



     
     
      {/* Newsletter Subscription */}
      <NewsLetterComp
        heading="Join our newsletter"
        text="Seasonal recipes, practical health notes, and the occasional offer."
      />

      {/* Social Icons and Footer Text */}
      <div className="flex flex-col items-center justify-center mt-4 rounded">
        {/* Social Icons */}
        <div className="mb-4">
          <SocialComp />
        </div>

        {/* About + clinic links — live here since the nav dropped its About
            heading. The two clinic links are site-wide on purpose: until
            2026-09-17 the only internal links to them were a nav dropdown
            reading "Manchester Clinic", which told Google nothing about what
            the pages are for. Anchor text is the point, so don't shorten it. */}
        <nav aria-label="About and clinic links" className="mb-4 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm">
          <Link
            href="/about"
            className="text-[var(--text-brand)] hover:underline"
            onClick={() => track("click", { label: "Footer > Our Story", component: "Footer" }, { event: "click", label: "Footer > Our Story", component: "Footer" })}
          >
            Our Story
          </Link>
          <Link
            href="/about/founder"
            className="text-[var(--text-brand)] hover:underline"
            onClick={() => track("click", { label: "Footer > Founder", component: "Footer" }, { event: "click", label: "Footer > Founder", component: "Footer" })}
          >
            Founder
          </Link>
          <Link
            href="/about/wellbeing-southport"
            className="text-[var(--text-brand)] hover:underline"
            onClick={() => track("click", { label: "Footer > Naturopathy in Southport", component: "Footer" }, { event: "click", label: "Footer > Naturopathy in Southport", component: "Footer" })}
          >
            Naturopathy in Southport
          </Link>
          <Link
            href="/about/wellbeing-manchester"
            className="text-[var(--text-brand)] hover:underline"
            onClick={() => track("click", { label: "Footer > Naturopathy in Manchester", component: "Footer" }, { event: "click", label: "Footer > Naturopathy in Manchester", component: "Footer" })}
          >
            Naturopathy in Manchester
          </Link>
        </nav>

        {/* Footer Text */}
        <FooterText />
      </div>
    </div>
  );
};

export default Footer;